import { sendToPatientOptions } from 'lib/constants/healthcareProgram/paymentSetup';

import { Alert } from 'components/shared/Alert/Alert';
import Disclosure from 'components/shared/Disclosure/Disclosure';
import Typography from 'components/shared/Typography/Typography';

const SendToPatients = ({ value, onChange }) => {
  const selectedOption = sendToPatientOptions.find((option) => option.value === value);

  return (
    <div className="flex w-full flex-col gap-1.5">
      <Typography variant="p" size="small">
        Letter to send patients
      </Typography>
      <div className="flex w-full flex-col gap-2">
        {sendToPatientOptions.map((option) => {
          const isActive = option.value === value;
          return (
            <Disclosure
              key={option.value}
              isOpen={isActive}
              onToggle={() => onChange(option.value)}
              title={option.title}
              disableOpen
              caption={option.caption}
              className="w-full"
              buttonClassName="py-2"
              bodyClassName="flex-col gap-0"
              radio
            />
          );
        })}
      </div>
      <Alert
        title="About this letter"
        message={selectedOption?.details}
        icon="bulb-filled"
        variant="lighter"
        className="w-full"
      />
    </div>
  );
};

export default SendToPatients;
